module.exports = __webpack_public_path__ + "img/hp2.142992ad.png";